import { FC, useMemo, useRef } from 'react';
import styles from './HouseMap.module.scss';
import 'leaflet/dist/leaflet.css';
import Typography from '@/components/UI/typography/Typography';
import Alert from '@/components/UI/alert/Alert';
import ShowMorePopUp from '../ShowMorePopUp/ShowMorePopUp';
import Box from '@/components/UI/box/Box';
import HouseDistances from '@/components/houses/_reusable/houseInfo/houseDistances/HouseDistances';
import React from 'react';
import { DistancesRecord, Location } from '@/components/houses/_types/productItem.types';
import dynamic from 'next/dynamic';
import useIntersection from '@/hooks/useIntersection';
const HouseMapContainer = dynamic(() => import('./houseMapContainer/HouseMapContainer'), {
  ssr: false
});
type Props = {
  distances: DistancesRecord[];
  location: Location;
};
const dirtLengthOptions = {
  0: 'مسیر خاکی ندارد.',
  100: 'خاکی تا ۱۰۰ متر',
  500: 'خاکی ۱۰۰ تا ۵۰۰ متر',
  1000: 'خاکی بیشتر از ۵۰۰ متر'
};
const timeOption = {
  5: 'کمتر از ۵ دقیقه',
  15: 'کمتر از ۱۵ دقیقه',
  30: 'کمتر از ۳۰ دقیقه',
  60: 'بیشتر از ۳۰ دقیقه',
  '': '-'
};
const HouseMap: FC<Props> = ({
  distances,
  location
}) => {
  const distancesData = useMemo(() => {
    const drivingDistances: any = [];
    const walkingDistances: any = [];
    distances?.map(item => {
      if (item.driving_time) {
        drivingDistances.push({
          distance: item.destination,
          time: timeOption[item.driving_time]
        });
      }
      if (item.walking_time) {
        walkingDistances.push({
          distance: item.destination,
          time: timeOption[item.walking_time]
        });
      }
    });
    return {
      drivingDistances,
      walkingDistances
    };
  }, [distances]);
  const position = [Number(location?.latitude) || 0, Number(location?.longitude) || 0];
  const ref = useRef<HTMLElement | null>(null);
  const isVisible = useIntersection(ref, '100px', true);
  return <>
      <Box className={styles['house-map-content']} id="location" component={'section'} data-sentry-element="Box" data-sentry-source-file="HouseMap.tsx">
        <Typography variant="bodyL_Bold" color="neutral_800" component="h2" data-sentry-element="Typography" data-sentry-source-file="HouseMap.tsx">
          موقعیت جغرافیایی
        </Typography>
        <Box ref={ref} className={styles['map-section']} data-sentry-element="Box" data-sentry-source-file="HouseMap.tsx">
          {isVisible && <HouseMapContainer position={position} />}
        </Box>
        {!!(distancesData.drivingDistances.length || distancesData.walkingDistances.length) && <Box className={styles['distance-content']}>
            {!!distancesData.drivingDistances.length ? <>
                <Alert type="secondary" title={dirtLengthOptions[location?.dirt_length || '']} icon="info-circle" />
                <Typography variant="bodyM_Bold" color="neutral_800" className={styles['title']} component="p">
                  دسترسی با خودرو
                </Typography>
                {distancesData.drivingDistances?.slice(0, 3).map((item, index) => {
            return <Box className={styles['distance-card']} key={`DISTANCES_CARD_${index}`}>
                        <Typography variant="bodyM" color="secondary_main">
                          {item.distance}
                        </Typography>
                        <Typography variant="bodyM" color="neutral_800">
                          {item?.time}
                        </Typography>
                      </Box>;
          })}
              </> : <>
                <Alert type="secondary" title={dirtLengthOptions[location?.dirt_length || '']} icon="info-circle" />
                <Typography variant="bodyM_Bold" color="neutral_800" className={styles['title']} component="p">
                  دسترسی پیاده
                </Typography>
                {distancesData.walkingDistances?.slice(0, 3).map((item, index) => {
            return <Box className={styles['distance-card']} key={`DISTANCES_CARD_${index}`}>
                        <Typography variant="bodyM" color="secondary_main">
                          {item.distance}
                        </Typography>
                        <Typography variant="bodyM" color="neutral_800">
                          {item?.time}
                        </Typography>
                      </Box>;
          })}
              </>}

            <ShowMorePopUp title="distances" btnText="مشاهده همه">
              <Typography variant="bodyL" color="neutral_800">
                <HouseDistances distancesData={distancesData} />
              </Typography>
            </ShowMorePopUp>
          </Box>}
      </Box>
    </>;
};
export default HouseMap;